module.exports = __webpack_public_path__ + "img/bth_beibu_nor.949ec783.png";